module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.extended) ? _c('router-link', {
    attrs: {
      "to": _vm.e.link
    },
    domProps: {
      "textContent": _vm._s(_vm.e.title)
    }
  }) : _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.e.title)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "date",
    domProps: {
      "textContent": _vm._s(_vm.dateAndPlace)
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-07cb9a7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/event/parts/title.vue
// module id = 153
// module chunks = 1